const AppConfig = {
    PRODUCTS: {
        PRODUCTS_PER_PAGE: 40,
    },
};

export default AppConfig;
